/*
 * Added by MORYARTY (MOD-069) — keep the cart drawer coherent with Globo Product Options.
 *
 * Globo links a poster's option add-ons (frame, material upgrade) as separate cart line items via
 * the hidden property `_gpo_parent_product_group`; the poster itself carries `_gpo_product_group`.
 * Globo's logic that removes those add-ons when their parent poster is removed runs ONLY on the
 * cart PAGE, never in Dawn's cart drawer — so removing a poster in the drawer used to orphan its
 * add-ons in the cart.
 *
 * This subscribes to Dawn's `cartUpdate` event and, after any cart change, removes any option line
 * item whose parent group is no longer present in the cart, then re-renders the open drawer.
 * Paired with hiding the per-add-on remove button (cart-drawer.liquid, MOD-069) so options can't be
 * removed individually — the cart is always managed at the poster level.
 *
 * Depends on Globo's property names (`_gpo_product_group` / `_gpo_parent_product_group`). If Globo
 * renames them, this no-ops (no orphans detected) rather than breaking. See MOD-069 in MODIFICATIONS.md.
 */
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  var busy = false;

  // Return the line-item `key`s of add-on products whose parent poster is no longer in the cart.
  function findOrphanKeys(items) {
    var parentGroups = {};
    items.forEach(function (item) {
      var group = item.properties && item.properties._gpo_product_group;
      if (group) parentGroups[String(group)] = true;
    });
    return items
      .filter(function (item) {
        var parent = item.properties && item.properties._gpo_parent_product_group;
        return parent && !parentGroups[String(parent)];
      })
      .map(function (item) {
        return item.key;
      });
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    if (busy) return;

    var cart = event && event.cartData;
    if (!cart || !cart.items || !cart.items.length) return;

    var orphanKeys = findOrphanKeys(cart.items);
    if (!orphanKeys.length) return;

    busy = true;

    var updates = {};
    orphanKeys.forEach(function (key) {
      updates[key] = 0;
    });

    var cartDrawer = document.querySelector('cart-drawer');
    var sections = cartDrawer
      ? cartDrawer
          .getSectionsToRender()
          .map(function (section) {
            return section.id;
          })
          .join(',')
      : '';

    fetch(window.routes.cart_update_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        updates: updates,
        sections: sections,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (state) {
        // Re-render only when the drawer is actually open, so a background cart change
        // (e.g. from the cart page) can't pop the drawer open.
        if (cartDrawer && state.sections && cartDrawer.classList.contains('active')) {
          cartDrawer.renderContents(state);
        }
      })
      .catch(function (error) {
        console.error('MOD-069: Globo orphan-option cleanup failed', error);
      })
      .finally(function () {
        busy = false;
      });
  });
})();
